import _ from 'underscore';

import { ColumnsConfigBuilder } from '@bingads-webui-campaign/summary-grid-helper';

import { CampaignColumn } from './attributes/campaign';
import { ListNameColumn } from './attributes/list-name';

export function getColumnsConfig({ options }) {
  let builder;
  const { scope: { campaignId } } = options;

  if (campaignId) {
    builder = new ColumnsConfigBuilder()
      .addCategory('Attribute', category => category.addColumns(_.compact([
        ListNameColumn,
      ])));
  } else {
    builder = new ColumnsConfigBuilder()
      .addCategory('Attribute', category => category.addColumns(_.compact([
        CampaignColumn,
        ListNameColumn,
      ])));
  }
  return builder.getColumnsConfig(options);
}

